import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Slideshow = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
  };

  return (
    <div style={{ width: "80%", margin: "0 auto" }}>
      <Slider {...settings}>
        <div>
          <img 
            src="\gallery2\preview_1.jpg" 
            alt="Img1" 
            style={{ width: "100%", height: "80vh", objectFit: "cover",}} 
          />
        </div>
        <div>
          <img 
            src="\gallery2\preview_2.jpg" 
            alt="Img2" 
            style={{ width: "100%", height: "80vh", objectFit: "cover" ,}} 
          />
        </div>
        <div>
          <img 
            src="\gallery2\preview_3.jpg" 
            alt="Img3" 
            style={{ width: "100%", height: "80vh", objectFit: "cover" ,}} 
          />
        </div>
        <div>
          <img 
            src="\gallery2\preview_4.jpg" 
            alt="Img4" 
            style={{ width: "100%", height: "80vh", objectFit: "cover" ,}} 
          />
        </div>
        <div>
          <img 
            src="\gallery2\preview_5.jpg" 
            alt="Img5" 
            style={{ width: "100%", height: "80vh", objectFit: "cover", }} 
          />
        </div>
        <div>
          <img 
            src="\gallery2\preview_6.jpg" 
            alt="Img6" 
            style={{ width: "100%", height: "80vh", objectFit: "cover", }} 
          />
        </div>
   
        
      </Slider>
    </div>
  );
};

export default Slideshow;
